import {Injectable} from '@angular/core';
import {PersonenTypEnum, PersonenTypEnumLabels, StammdatenBerater} from '@nachdigal';
import {MappedStammdatenBerater} from '@utils-lib';
import {InlandsadresseMapperService} from './inlandsadresse-mapper.service';
import {PersonMapperService} from './person-mapper.service';
import {AuslandsadresseMapperService} from './auslandsadresse-mapper.service';
import {KommunikationsmittelMapperService} from './kommunikationsmittel-mapper.service';
import {AbstractMapper} from '../../abstract.mapper';
import {JuristischePersonMapperService} from './juristische-person-mapper.service';
import {PostfachadresseMapperService} from './postfachadresse-mapper.service';

@Injectable()
export class BeraterMapperService extends AbstractMapper<StammdatenBerater, MappedStammdatenBerater> {

  constructor(
    private readonly personMapper: PersonMapperService,
    private readonly juristischePersonMapper: JuristischePersonMapperService,
    private readonly inlandsadresseMapper: InlandsadresseMapperService,
    private readonly auslandsadresseMapper: AuslandsadresseMapperService,
    private readonly postfachadresseMapper: PostfachadresseMapperService,
    private readonly kommunikationsmittelMapper: KommunikationsmittelMapperService
  ) {
    super();
  }

  private static mapPersonenTyp(source: StammdatenBerater.TypEnum): PersonenTypEnum {
    if (source === StammdatenBerater.TypEnum.NUMBER_0) {
      return PersonenTypEnumLabels.NatPers;
    }
    if (source === StammdatenBerater.TypEnum.NUMBER_1) {
      return PersonenTypEnumLabels.NNatPers;
    }
    return null;
  }

  protected mapInternal(source: StammdatenBerater): MappedStammdatenBerater {
    return {
      personenTyp: BeraterMapperService.mapPersonenTyp(source.typ),
      natuerlichePerson: this.personMapper.map(source.natuerlichePerson),
      juristischePerson: this.juristischePersonMapper.map(source.juristischePerson),
      inlandsadressen: this.inlandsadresseMapper.mapArrayWithDefault(source.adressen),
      auslandsadressen: this.auslandsadresseMapper.mapArrayWithDefault(source.adressen),
      postfachadressen: this.postfachadresseMapper.mapArrayWithDefault(source.adressen),
      kommunikation: this.kommunikationsmittelMapper.map(source.kommunikation)
    };
  }
}
